import { object } from 'prop-types';
import * as React from 'react';

import { RestApiManager } from '../../api/RestApiManager';

export interface ApiManagerProviderProps {
    api: RestApiManager;
    children: JSX.Element;
}

export class ApiManagerProvider extends React.Component<
    ApiManagerProviderProps
> {
    static childContextTypes = {
        apiManager: object
    };

    render() {
        return this.props.children;
    }

    getChildContext() {
        return { apiManager: this.props.api };
    }
}
